import { render, staticRenderFns } from "./Passo3.vue?vue&type=template&id=584e6c00&scoped=true&"
import script from "./Passo3.vue?vue&type=script&lang=js&"
export * from "./Passo3.vue?vue&type=script&lang=js&"
import style0 from "./Passo3.vue?vue&type=style&index=0&id=584e6c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e6c00",
  null
  
)

export default component.exports